import axios from "axios";
import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useCookies } from "react-cookie";
import { IoClose } from "react-icons/io5";
import globalContext from "../../Contexts/GlobalContext";
import BlueLoader from "../loader/Loader";
import { useNavigate } from "react-router-dom";
import { SERVERMESSAGE } from "../../constants/serverMessage";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import useRequestHeader from "../../hooks/useRequestHeader";

export default function InformationModal({ message, mode, setSMFMethod }) {
  const navigate = useNavigate();
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const requestHeader = useRequestHeader();
  const contextData = useContext(globalContext);

  const [isLoading, setIsLoading] = useState(false);
  return (
    <div
      className="absolute w-full h-screen backdrop-blur-sm flex items-center justify-center z-[1000]"
      id="bg"
      onClick={(e) => {
        if (e.target.id === "bg") {
          if (mode === "repairAdd") contextData.setIsRepairAdd(false);
          if (mode === "first") contextData.setIsFirstCar(false);
        }
      }}
    >
      <div
        className={`relative w-[80vw] pb-[3vw] bg-[#001D26] border-color-primary-D  flex flex-col items-center justify-evenly border-[1px] z-[800] rounded-[1vw] `}
      >
        <div
          className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038]  "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span className="py-[2vw]">توضیحات</span>
        </div>

        <p
          className={`w-full flex items-center font-extralight text-justify text-[4vw] z-[800] text-color-primary-C3 px-[5vw] font-font_primary_A mt-[4.5vw] leading-[6.5vw]`}
        >
          {/* {message} */}
          {mode === "repairAdd" && typeof message === "object" ? (
            <>{`وسیله نقلیه  ${message.company} با مدل ${
              message.model
            } در سامانه اسکارپین در تاریخ ${moment(
              new Date(message.submitDate.slice(0, 10))
            )
              .locale("fa")
              .format("YYYY/M/D")} 
               توسط تعمیرگاه با شماره صنفی ${
                 message.repairID
               }ثبت شده است . آیا این خودرو متعلق به شماست ؟`}</>
          ) : (
            message
          )}
        </p>

        {mode === "repairAdd" ? (
          <>
            <div className="flex items-center justify-between gap-x-[3vw] mt-[3.7vw]">
              <button
                className="relative w-[32vw] h-[8vw]  rounded-[1vw] text-center flex items-center justify-center text-[#F8F8F3] font-font_primary_A text-[4vw] bg-[#153038] z-[1000]"
                onClick={() => {
                  setSMFMethod(true);
                  contextData?.setChangeKmModalIsOpen(true);
                  contextData.setIsRepairAdd(false);
                }}
              >
                بله
              </button>
              <button
                className="relative w-[32vw] h-[8vw] rounded-[1vw] text-center flex items-center justify-center text-[#AF3434] font-font_primary_A text-[4vw] bg-[#001D26] z-[1000]"
                onClick={() => {
                  //   setIsConformationModalOpen(false);

                  setIsLoading(true);
                  const config = {
                    headers: requestHeader,
                  };
                  axios
                    .post(
                      `${BASE_URL}/car/wrongCar`,
                      {
                        plate: cookies?.plate,
                      },
                      config
                    )
                    .then((res) => {
                      var responseMode = res?.data?.Mode;
                      var responseMessage = res?.data?.Message;
                      switch (responseMode) {
                        case SERVERMODE.REQUEST_OK: {
                          contextData.setIsRepairAdd(false);
                          contextData.setIsToastOpen(true);
                          contextData.setToastMessage(
                            SERVERMESSAGE.SUCCESS_DESTROY_CAR
                          );
                          contextData.setIsRepairAdd(false);
                          navigate("/add-car");
                          break;
                        }
                        default: {
                          handleServerMode(
                            responseMode,
                            responseMessage,
                            contextData,
                            cookies,
                            removeCookies,
                            navigate
                          );
                        }
                      }
                      setIsLoading(false);
                    })
                    .catch((err) => {
                      setIsLoading(false);
                      contextData.setIsToastOpen(true);
                      contextData.setToastMessage(
                        "ارتباط با سرور دچار مشکل شده است"
                      );
                      contextData.setIsRepairAdd(false);
                    });
                }}
              >
                {isLoading ? <BlueLoader width={10} /> : "خیر"}
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
